import { createFileRoute } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import { data } from '~/data/basic';
import { PageSection } from '~/routes/__root';
import { langStore } from '~/store/langStore';
import { cn } from '~/utils';

export const Route = createFileRoute('/volunteer')({
  component: RouteComponent,
});

function RouteComponent() {
  const locale = useStore(langStore, s => s);
  return (
    <PageSection className="mb-[-95px] flex min-h-[70vh] w-full flex-col justify-between text-white md:flex-row">
      <a
        href={data.volunteer.buildingLink}
        className={cn(
          'group flex h-[50vh] w-full cursor-pointer items-center justify-center bg-cover bg-center transition-colors duration-200 md:h-screen',
          `bg-[url('/szepito.jpg')]`,
        )}
        style={{
          backgroundBlendMode: 'multiply',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        }}
      >
        <div className="group-hover:text-yellow z-10 text-center text-5xl font-bold uppercase">
          {data.volunteer.camp[locale]}
        </div>
      </a>

      <a
        href={data.volunteer.volunteerLink}
        className={cn(
          'group flex h-[50vh] w-full cursor-pointer items-center justify-center bg-cover bg-center transition-colors duration-200 md:h-screen',
          `bg-[url('/onkentes.jpg')]`,
        )}
        style={{
          backgroundBlendMode: 'multiply',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        }}
      >
        <div className="group-hover:text-yellow text-center text-5xl font-bold uppercase">
          {data.volunteer.festival[locale]}
        </div>
      </a>
    </PageSection>
  );
}
